const { get } = require('lodash');

module.exports = function (value) {
  const v = get(value, 'value', '');
  return Array.isArray(v) ? v[0] || '' : v;
};
